import styled from '@emotion/styled';
import { Variables } from '../../base';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const Label = styled.div`
    font-family: 'Inter', ${Variables.Fonts.calibre};
    font-size: 12px;
    font-weight: ${Variables.FontWeight.semibold};
    color: ${Variables.Colors.slate500};
    text-transform: uppercase;
    letter-spacing: 0.6px;
    line-height: 16px;
`;

interface IWrapperProps {
    disabled?: boolean;
    isNote?: boolean;
}
export const Wrapper = styled.div<IWrapperProps>`
    display: flex;

    border: 1px solid ${Variables.Colors.slate300};
    border-radius: 8px;
    background-color: ${Variables.Colors.white};
    ${(props: IWrapperProps) =>
        props.disabled &&
        `
        background-color: ${Variables.Colors.n15_24};
        border-color: ${Variables.Colors.n15};
    `}
    ${(props: IWrapperProps) =>
        props.isNote &&
        `
        background-color: ${Variables.Colors.b300_l96};
        border-color: ${Variables.Colors.b300_l90};
        input {
            color:  ${Variables.Colors.b300_l62};
        }
    `}
`;

export const Input = styled.input`
    flex-grow: 1;

    background-color: transparent;
    border: none;

    outline: none;
    flex-grow: 1;
    height: auto;
    font-size: 14px;

    min-height: 17px;
    resize: none;

    padding: 14px 17px 15px 17px;

    &::placeholder {
        color: ${Variables.Colors.slate400};
    }

    &:disabled {
        border-color: ${Variables.Colors.n15};
    }
`;
